import * as actions from "../constants/ActionTypes";

const initialState = {
    products: [],
    selectedProduct: {
        image: null,
        description: null,
        title: null,
		price: null,
		loading: true,
		quantity: 1
	},
	productsLoading: false,
	productFilters: [],
	searchTerm: '',
	sortBy: 'name',
	productCategories: [],
	selectedProductCategory: null,
	loadingCategories: false
};

export default function shop(state = initialState, action) {
    switch (action.type) {
		case actions.FETCH_PRODUCTS:
            return {
				...state,
				products: [],
				productsLoading: true
			}
        case actions.FETCH_PRODUCTS_SUCCESS:
            return {
				...state,
				products: action.products,
				productsMeta: action.productsMeta,
				productsLoading: false
			}
		case actions.FETCH_PRODUCT_SUCCESS:
            return {
				...state,
				selectedProduct: {...action.selectedProduct, loading: false}
			}
		case actions.FETCH_PRODUCT_FAIL:
            return {
				...state,
				selectedProduct: {...initialState.selectedProduct, loading: false}
			}
		case actions.FETCH_PRODUCT_CATEGORIES:
            return {
				...state,
				loadingCategories: true
			}
		case actions.FETCH_PRODUCT_CATEGORIES_SUCCESS:
            return {
				...state,
				productCategories: action.productCategories,
				loadingCategories: false
			}
        case actions.SET_VIEW_PRODUCT_ID:
            return Object.assign({}, state, {
                productId: action.productId
            })
        case actions.SET_SELECTED_PRODUCT:
            return Object.assign({}, state, {
                selectedProduct: action.selectedProduct
			})
		case actions.SET_SELECTED_PRODUCT_CATEGORY:
			return {
				...state,
				selectedProductCategory: action.productCategoryId
			}
		case actions.SET_PRODUCT_QUANTITY:
            return {
				...state,
				selectedProduct: {...state.selectedProduct, quantity: action.quantity}
			}
		case actions.SET_PRODUCT_SEARCH_TERM:
			return {
				...state,
				searchTerm: action.searchTerm
			}
		case actions.SHOP_SORT_BY:
			return {
				...state,
				sortBy: action.value
			};
		case actions.FETCH_PRODUCT_BUNDLES_SUCCESS:
            return {
				...state
			}
        default:
            return state
    }
}
